import { ApolloClient, gql } from 'apollo-boost';

const updateIndicatorAnswerQuery = gql`
  mutation updateNpoAnswer(
    $id: Int
    $questionId: Int!
    $reportId: Int
    $text: String
    $ignoreClearData: Boolean
  ) {
    updateNpoAnswer(
      id: $id
      questionId: $questionId
      reportId: $reportId
      text: $text
      ignoreClearData: $ignoreClearData
    ) {
      id
      success
      nextQuestion
    }
  }
`;

const indicatorsUpdatedTextQuery = gql`
  query reportsByResult($reportId: ID) {
    allReports(filters: { id: $reportId }) {
      edges {
        node {
          dbId
          results {
            edges {
              node {
                dbId
                description
                seen
                successCriteria
                indicatorId
                indicator {
                  name
                  definition
                  stageId
                  stgName
                  version
                  unit
                  definitionStart
                  definitionEnd
                  serviceGoal
                  isHuman
                  initialForecastStart
                  initialForecastEnd
                  initialMeasurementStart
                  initialMeasurementEnd
                  finalForecastStart
                  finalForecastEnd
                  finalMeasurementStart
                  finalMeasurementEnd
                  impactReceiptText
                  outcome
                  forecastOutcome
                  finalOutcome
                }
              }
            }
          }
        }
      }
    }
  }
`;

const updateSuccessCriteriaQuery = gql`
  mutation addSuccessCriteria(
    $reportId: Int!
    $indicatorId: Int!
    $successCriteria: String
    $seen: Boolean
  ) {
    addSuccessCriteria(
      reportId: $reportId
      indicatorId: $indicatorId
      successCriteria: $successCriteria
      seen: $seen
    ) {
      success
      id
    }
  }
`;

export interface UpdateReportResponse {
  updateNpoAnswer: {
    id: number;
    // there is no next question in this case
    nextQuestion: { dbId: null };
    success: true;
  };
}

export const updateIndicatorAnswer = (
  client: ApolloClient<object>,
  id: number | undefined = undefined, // answerId
  ignoreClearData: boolean,
  questionId: number,
  reportId: number | string,
  text: string[] | string,
) => {
  return client.mutate({
    mutation: updateIndicatorAnswerQuery,
    variables: {
      id,
      answerId: id,
      ignoreClearData,
      questionId,
      reportId,
      text,
    },
    fetchPolicy: 'no-cache',
  });
};

export const getIndicatorsUpdatedText = (
  client: ApolloClient<object>,
  reportId: number | string,
) => {
  return client.query({
    query: indicatorsUpdatedTextQuery,
    variables: {
      reportId,
    },
    fetchPolicy: 'no-cache',
  });
};

export const updateSuccessCriteria = (
  client: ApolloClient<object>,
  reportId: number | string,
  indicatorId: number,
  seen: boolean, // indicator is shown to the user
  successCriteria: string | undefined, // updated text
) => {
  return client.query({
    query: updateSuccessCriteriaQuery,
    variables: {
      reportId,
      indicatorId,
      successCriteria,
      seen,
    },
    fetchPolicy: 'no-cache',
  });
};
